import axios from "axios";
import initialSettings from "../constants/settings.json";
import { storageKeys } from "../constants/storageKeys"; 

/**
 * Generates BPMN XML from a JSON BPMN object.
 * @param {Object} jsonBPMN - BPMN JSON to translate.
 * @param {AbortSignal} [signal] - Optional AbortSignal for request cancellation.
 * @returns {Promise<any>}
 */
export async function generateBPMNXML(jsonBPMN, signal = undefined) {

  // The base URL is stored in localStorage and set through Settings
  const baseUrl = JSON.parse(localStorage.getItem(storageKeys.BPMN_TRANSLATOR_SERVICE_URL)) 
                  || initialSettings.localStorage.BPMN_TRANSLATOR_SERVICE_URL;
  
  try {
    const response = await axios.post(
      baseUrl,
      jsonBPMN,
      {
        headers: { 'Content-Type': 'application/json' },
        ...(signal ? { signal } : {})
      }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
}